export default "__VITE_ASSET__DZNtrZ1M__"